<template>
  <div
    class="nav-desktop-link-container"
    :class="{ 'nav-desktop-link--subdrop-open': open }"
    v-on="handleSubdropToggle"
  >
    <component
      :is="parsedLink ? 'T3Link' : 'div'"
      :to="parsedLink || null"
      class="nav-desktop-link"
    >
      <span @click="handleLinkClick">
        {{ link.title }}
      </span>
    </component>

    <NavDesktopSubdrop
      v-if="withSubdrop"
      :root-link="link"
      :open="open!"
      :lang="lang"
      @link-click="handleLinkClick"
    >
      <slot />
    </NavDesktopSubdrop>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { INavigation, INavigationWithMedia } from '~ui/types'

const props = defineProps<{
  link: INavigation | INavigationWithMedia
  index?: number
  open?: boolean
  lang: string
}>()

const parsedLink = computed(() => {
  if (props.link.spacer) return null
  return { link: props.link.link, target: props.link.target }
})

const withSubdrop = computed(() => {
  return Array.isArray(props.link.children) && props.link.children.length
})

const emit = defineEmits<{
  (event: 'link-click'): void
  (event: 'toggle-subdrop', index?: number): void
}>()

const handleSubdropToggle = withSubdrop.value
  ? {
    mouseover: () => {
      emit('toggle-subdrop', props.index)
    },
    mouseleave: () => {
      emit('toggle-subdrop')
    }
  }
  : {}

const handleLinkClick = () => emit('link-click')
</script>

<style lang="scss">
.nav-desktop-link {
  position: relative;
  color: color(grey-800);
  padding-inline: range-clamp(0px, 6px, 1100px, 1400px);
  display: inline-block;
  height: 100%;
  text-wrap: nowrap;

  &-container {
    height: 100%;
  }

  & > span {
    display: inline-flex;
    align-items: center;
    height: 100%;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: rem(3px);
    width: 100%;
    background-color: color(primary);
    border-top-left-radius: em(1px);
    border-top-right-radius: em(1px);
    scale: 1 0;
    transform-origin: bottom;
    transition:
      scale 0.2s,
      background-color 0.2s;
  }

  &:where(.router-link-exact-active)::before {
    scale: 1;
    background-color: rgba(color(primary), 40%);
  }

  &--subdrop-open &::before {
    scale: 1;
  }

  &:is(:active, :focus):not(:is(:hover)) {
    color: color(grey-800);
  }

  &:is(:hover)::before {
    scale: 1;
    background-color: color(primary);
  }

  .header--themed :where(&) {
    color: color(white);

    &:is(:active, :focus):not(:is(:hover)) {
      color: color(white);
    }
  }
}
</style>
